module.exports = __webpack_public_path__ + "img/logo-white.186559c.svg";